import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=4bfc9130&scoped=true&"
import script from "./tutorial.vue?vue&type=script&lang=js&"
export * from "./tutorial.vue?vue&type=script&lang=js&"
import style0 from "./tutorial.vue?vue&type=style&index=0&id=4bfc9130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc9130",
  null
  
)

export default component.exports